<template>
  <div class="relative overflow-hidden -mt-16" style="height: 25rem">
    <div class="absolute w-full h-full">
      <slot name="avatar"></slot>
    </div>
    <div
      class="absolute w-full h-full"
      :style="`background: ${overlayColor}; opacity: ${overlayOpacity / 100}`"
    ></div>
    <div class="absolute w-full h-full flex items-center justify-center px-20">
      <slot name="story"></slot>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Hero',
  props: {
    bgColor: {},
    overlayColor: {},
    overlayOpacity: {},
  },
};
</script>
